'use client'

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState, type ReactNode } from 'react'
import { HeaderScrollProvider } from '@/components/layout/header-scroll-context'
import { CommunityCartProvider } from '@/components/community/cart/community-cart-provider'

export function Providers({ children }: { children: ReactNode }) {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 1000 * 60 * 5, // 5 minutes
            refetchOnWindowFocus: false,
          },
        },
      }),
  )

  return (
    <QueryClientProvider client={queryClient}>
      <HeaderScrollProvider>
        <CommunityCartProvider>{children}</CommunityCartProvider>
      </HeaderScrollProvider>
    </QueryClientProvider>
  )
}
